"use client"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { DemoForm } from "@/components/demo-form"

export function DemoSection() {
  return (
    <section className="py-16 sm:py-20 bg-gradient-to-br from-[#1785CA]/5 via-white to-[#34D1BE]/5">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl lg:text-4xl font-light text-gray-900 tracking-tight">Ready to transform your Health Insurance Business?</h2>
          <p className="mt-3 text-[0.9rem] sm:text-lg text-gray-600">
            Book a 30-minute demo to experience how OctoHealth ERP uses AI to streamline operations, reduce costs, and power smarter decisions.
          </p>
        </div>

        <Card className="animated-border relative w-full max-w-3xl mx-auto bg-white/70 backdrop-blur-md shadow-xl rounded-3xl transition-all hover:shadow-2xl hover:scale-[1.01]">
          <CardHeader className="pb-0 text-center">
            <CardTitle className="text-2xl font-light">Schedule a demo</CardTitle>
          </CardHeader>
          <CardContent className="pt-6">
            <DemoForm />
          </CardContent>
        </Card>
      </div>
    </section>
  )
}
